import { render, staticRenderFns } from "./SettingsTab.vue?vue&type=template&id=d672e072&scoped=true&"
import script from "./SettingsTab.vue?vue&type=script&lang=js&"
export * from "./SettingsTab.vue?vue&type=script&lang=js&"
import style0 from "./SettingsTab.vue?vue&type=style&index=0&id=d672e072&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d672e072",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VCard,VCheckbox,VDivider,VIcon,VProgressLinear})
